var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"button-icon",class:[_vm.styleClassName, _vm.sizeClassName, _vm.squareClassName],attrs:{"to":_vm.to}},[_c('AppIcon',{staticClass:"button-icon__icon",attrs:{"size":_vm.size,"icon":_vm.icon}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }